"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const picker_1 = require("@react-native-picker/picker");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const usePaginator_1 = __importDefault(require("../../hooks/usePaginator"));
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const themes_1 = __importDefault(require("../../styles/themes"));
const paginationStyles_1 = __importDefault(require("./paginationStyles"));
const Pagination = ({ totalPages, currentPage, totalEntries, onPageChange, pageSize, }) => {
    const nextPage = currentPage + 1 > totalPages ? currentPage : currentPage + 1;
    const pageNumbersToDisplay = [...Array(totalPages).keys()].map((number) => number + 1);
    const previousPage = currentPage - 1 < 1 ? 1 : currentPage - 1;
    const pageSelectHandler = (page) => {
        onPageChange(page);
    };
    const { pageStart, pageEnd } = usePaginator_1.default(currentPage, totalPages, pageSize, totalEntries);
    const label = `Showing ${pageStart} - ${pageEnd} of ${totalEntries}`;
    return (react_1.default.createElement(react_native_1.View, { style: [
            styles_1.default.flexDirectionRow,
            styles_1.default.alignItemsCenter,
            styles_1.default.alignLeft,
            styles_1.default.marginTen,
        ] },
        react_1.default.createElement(picker_1.Picker, { selectedValue: currentPage, onValueChange: pageSelectHandler, style: [paginationStyles_1.default.select], itemStyle: [styles_1.default.textTitle] }, pageNumbersToDisplay.map((page) => (react_1.default.createElement(picker_1.Picker.Item, { color: page === currentPage ? colors_1.default.GRAY_3 : colors_1.default.BLUE, enabled: page !== currentPage, label: `page ${page}`, key: page, value: page })))),
        react_1.default.createElement(react_native_paper_1.Text, { style: [styles_1.default.textColorGray, styles_1.default.marginTen] }, label),
        react_1.default.createElement(react_native_paper_1.IconButton, { icon: "chevron-left", iconColor: colors_1.default.BLUE, size: 25, disabled: currentPage === previousPage, onPress: () => onPageChange(previousPage), theme: themes_1.default.datatable }),
        react_1.default.createElement(react_native_paper_1.IconButton, { icon: "chevron-right", iconColor: colors_1.default.BLUE, size: 25, disabled: currentPage === nextPage, onPress: () => onPageChange(nextPage), theme: themes_1.default.datatable })));
};
exports.default = Pagination;
